/*
 * @描叙: 解析表计信息读数 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-02-21 15:55:59 
*/

// 定义表计类型-表计型号对应关系
const WENKONGQI = ['FC810', 'FC811', 'FC812', 'FC815', "FC109R"]; //  温控器
const FENGGUI = ['FC890'];  //  风柜
const RELIANGBIAO = ['HM01'];   //  热量表

// 风柜故障定义
const FENGGUI_FAULT = {
    'E1': '风机过载报警',
    'E2': '风机压差报警',
    'E3': '防冻开关报警',
    'E4': '过滤网压差报警',
    'E5': '中效过滤网压差报警',
    'E6': '送、回风NTC传感器故障',
    'E7': '外环境NTC传感器故障',
    'E11': '数据存储故障',
    'E18': '计量参数未设定故障',
}

// 温控器故障定义
const WENKONGQI_FAULT = {
    'sensor_error': '传感器故障',
    'datastore_error': '数据存储故障',
    'invalid_port_params': '端口未设定参数报警',
    'vavle_force_on': '水阀强迫运行报警',
    'speed_ctrl_line_error': '三风速接线错误报警',
    'fan_offline': '风机脱线报警',
}

// 表计类型
function deviceType(model) {
    if (WENKONGQI.indexOf(model) >= 0) {
        return { name: '温控器', type: 1 }
    }
    if (FENGGUI.indexOf(model) >= 0) {
        return { name: '风柜', type: 2 }
    }
    if (RELIANGBIAO.indexOf(model) >= 0) {
        return { name: '热量表', type: 3 }
    }
    return { name: '', type: 1 }
}

// 温控器
function wenkongqiInfo(data) {
    let obj = {};
    obj._data = Object.assign({}, data);   //  保存原始数据

    // 温控器运行状态
    obj.linkStatus = fmtStr_0_1(data.link_status, '正常', '离线');
    obj.modeStatus = fmtStr_0_1(data.mode_status, '冬季供热', '夏季供冷');
    obj.balanceAlarm = fmtStr_0_1(data.balance_alarm, '正常使用', '余额提醒');
    obj.disabled = fmtStr_0_1(data.mode_status, '正常使用', '停用状态');
    obj.allowCharging = fmtStr_0_1(data.allow_charging, '停止计费', '允许计费');
    obj.factoryMode = fmtStr_0_1(data.factory_mode, '正常模式', '调试模式');
    obj.powerOn = fmtStr_0_1(data.setting_power_on, '关机', '开机');

    let { sensor_error, datastore_error, invalid_port_params, vavle_force_on, speed_ctrl_line_error, fan_offline } = data
    obj.fault = { sensor_error, datastore_error, invalid_port_params, vavle_force_on, speed_ctrl_line_error, fan_offline };   //  风盘故障状态
    obj.faultMsg = fenggui_faultStatus(obj.fault, WENKONGQI_FAULT);
    obj.sysStatusResult = '正常'
    if (obj.faultMsg.length > 0) {     //  风盘故障状态
        obj.sysStatusResult = '故障'
    }

    // 风盘累计
    obj.fcuCounterInt = data.fcu_counter_int;
    obj.fcuCounterFrac = data.fcu_counter_frac;
    obj.fcuCounter = data.fcu_counter_int + (data.fcu_counter_frac / 100);

    // 风盘运行状态
    obj.fcuInCounting = fmtStr_0_1(data.fcu_in_counting, '暂停计量', '正在计量中');
    obj.hasFloorHeating = fmtStr_0_1(data.has_floor_heating, '无', '有');
    obj.valve2On = fmtStr_0_1(data.valve2_on, '', '水阀2打开');  //  四管制
    obj.valve1On = fmtStr_0_1(data.valve1_on, '', '水阀1打开');
    obj.fcuHighSpeed = fmtStr_0_1(data.fcu_high_speed, '', '高风速运行');
    obj.fcuMediumSpeed = fmtStr_0_1(data.fcu_medium_speed, '', '高风速运行');
    obj.fcuLowSpeed = fmtStr_0_1(data.fcu_low_speed, '', '低风速运行');

    return obj;
}
// 风柜
function fengguiInfo(data) {
    let obj = {};
    obj._data = Object.assign({}, data);   //  保存原始数据

    obj.isRunning = fmtStr_0_1(data.is_running, '停机', '运行');
    obj.sysStatus = fmtStr_0_1(data.sys_status, '正常', '故障');
    let { E1, E2, E3, E4, E5, E6, E7, E11, E18 } = data;
    obj.fault = { E1, E2, E3, E4, E5, E6, E7, E11, E18 };   //  温控器故障
    obj.faultMsg = fenggui_faultStatus(obj.fault, FENGGUI_FAULT);

    if (data.sys_status === 0 && obj.faultMsg.length > 0) {     //  正常状态下有故障，还是显示故障状态
        obj.sysStatusResult = '故障'
    }

    // 当量风柜计量状态
    obj.linkStatus = fmtStr_0_1(data.link_status, '通讯正常', '通讯中断');
    obj.inCounting = fmtStr_0_1(data.in_counting, '未计量', '正在计量中');
    obj.modeStatus = fmtStr_0_1(data.mode_status, '冬季供热', '夏季供冷');
    obj.balanceAlarm = fmtStr_0_1(data.balance_alarm, '正常使用', '余额提醒');
    obj.disabled = fmtStr_0_1(data.disabled, '正常使用', '停用状态');
    obj.allowCharging = fmtStr_0_1(data.allow_charging, '停止计费', '允许计费');
    obj.factoryMode = fmtStr_0_1(data.factory_mode, '正常模式', '调试模式');
    obj.settingPowerOn = fmtStr_0_1(data.setting_power_on, '关机', '开机');
    // 风柜累计
    obj.counterTotalInt = data.counter_total_int;
    obj.counterTotalFrac = data.counter_total_frac;
    obj.counterTotal = data.counter_total_int + (data.counter_total_frac / 100);

    obj.tsensorType = data.tsensor_type;   //  温度传感器类型：0:NTC，1:0-10V，2:4-20mA
    obj.tsensorValue = data.tsensor_value;     //  温度传感器温度  0-500(0-50℃)

    obj.hsensorType = data.hsensor_type;   //  湿度传感器类型  1:0-10V，2:4-20mA
    obj.hsensorValue = data.hsensor_value;     //  湿度传感器湿度  0-1000(0-100%)

    obj.extsensorType = data.extsensor_type;   //  外环境传感器类型    0:NTC，1:0-10V，2:4-20mA
    obj.extsensorValue = data.extsensor_value;     //  外环境传感器温度    0-500(0-50℃)

    obj.psensorType = data.psensor_type;   //  静压传感器类型: 1:0-10V，2:4-20mA
    obj.psensorValue = data.psensor_value;     //  静压传感器压力  0-1000

    obj.waterValveAperture = data.water_valve_aperture;    //  水阀输出开度   1-100
    obj.humidifierOn = fmtStr_0_1(data.humidifier_on, '关闭', '运行');  //  开关量加湿阀输出状态   '0=关闭,1=运行
    obj.humidifierAperture = data.humidifier_aperture;    //  比例加湿阀输出开度  1-100

    obj.fanMotorOn = fmtStr_0_1(data.fan_motor_on, '关闭', '运行');  //  风机运行状态   '0=关闭,1=运行

    obj.vffanFreq = data.vffan_freq;   //  变频风机输出频率: 0-500(0-50.0Hz)
    obj.fauAperture = data.fau_aperture;     //  浮点新风阀输出开度  1-100
    obj.fauOn = fmtStr_0_1(data.fau_on, '关闭', '运行');    //  开关量新风阀输出状态: 1:0-10V，2:4-20mA

    return obj;

}

// 热量表
function reliangbiaoInfo(data) {
    let obj = {};
    obj._data = data;   //  保存原始数据
    // cool = cool.toString(10)
    //累计冷量
    let cool
    if (obj._data.cooling_capacity_unit) {
        cool = obj._data.cooling_capacity_unit.toString(16)
    } else {
        cool = 'hh'
    }
    if (cool == '2') {
        obj.coolingCapacity = data.cooling_capacity + "(Wh)"
    } else if (cool == '3') {
        obj.coolingCapacity = data.cooling_capacity + "(10Wh)"
    } else if (cool == '4') {
        obj.coolingCapacity = data.cooling_capacity + "(100Wh)"
    } else if (cool == '5') {
        obj.coolingCapacity = data.cooling_capacity + "(KWh)"
    } else if (cool == 'b') {
        obj.coolingCapacity = data.cooling_capacity + "(KJ)"
    } else if (cool == 'c') {
        obj.coolingCapacity = data.cooling_capacity + "(10KJ)"
    } else if (cool == 'd') {
        obj.coolingCapacity = data.cooling_capacity + "(100KJ)"
    } else if (cool == 'e') {
        obj.coolingCapacity = data.cooling_capacity + "(MJ)"
    } else if (cool == 'f') {
        obj.coolingCapacity = data.cooling_capacity + "(10MJ)"
    } else if (cool == '10') {
        obj.coolingCapacity = data.cooling_capacity + "(100MJ)"
    } else if (cool == '11') {
        obj.coolingCapacity = data.cooling_capacity + "(GJ)"
    } else if (cool == '12') {
        obj.coolingCapacity = data.cooling_capacity + "(10GJ)"
    } else if (cool == '13') {
        obj.coolingCapacity = data.cooling_capacity + "(100GJ)"
    } else {
        obj.coolingCapacity = data.cooling_capacity
    }
    //累计热量
    let heat
    if (obj._data.heating_capacity_unit) {
        heat = obj._data.heating_capacity_unit.toString(16)
    } else {
        heat = 'hh'
    }
    if (heat == '2') {
        obj.heatingCapacity = data.heating_capacity + "(Wh)"
    } else if (heat == '3') {
        obj.heatingCapacity = data.heating_capacity + "(10Wh)"
    } else if (heat == '4') {
        obj.heatingCapacity = data.heating_capacity + "(100Wh)"
    } else if (heat == '5') {
        obj.heatingCapacity = data.heating_capacity + "(KWh)"
    } else if (heat == 'b') {
        obj.heatingCapacity = data.heating_capacity + "(KJ)"
    } else if (heat == 'c') {
        obj.heatingCapacity = data.heating_capacity + "(10KJ)"
    } else if (heat == 'd') {
        obj.heatingCapacity = data.heating_capacity + "(100KJ)"
    } else if (heat == 'e') {
        obj.heatingCapacity = data.heating_capacity + "(MJ)"
    } else if (heat == 'f') {
        obj.heatingCapacity = data.heating_capacity + "(10MJ)"
    } else if (heat == '10') {
        obj.heatingCapacity = data.heating_capacity + "(100MJ)"
    } else if (heat == '11') {
        obj.heatingCapacity = data.heating_capacity + "(GJ)"
    } else if (heat == '12') {
        obj.heatingCapacity = data.heating_capacity + "(10GJ)"
    } else if (heat == '13') {
        obj.heatingCapacity = data.heating_capacity + "(100GJ)"
    } else {
        obj.heatingCapacity = data.heating_capacity
    }
    //  功率
    let powerunit
    if (obj._data.power_unit) {
        powerunit = obj._data.power_unit.toString(16)
    } else {
        powerunit = 'hh'
    }
    if (powerunit == '14') {
        obj.power = data.power + "(W)"
    } else if (powerunit == '15') {
        obj.power = data.power + "(10W)"
    } else if (powerunit == '16') {
        obj.power = data.power + "(100W)"
    } else if (powerunit == '17') {
        obj.power = data.power + "(KWh)"
    } else {
        obj.power = data.power
    }
    //  瞬时流量
    let inst
    if (obj._data.instant_discharge_unit) {
        inst = obj._data.instant_discharge_unit.toString(16)
    } else {
        inst = 'hh'
    }
    if (inst == '2f') {
        obj.instantDischarge = data.instant_discharge + "(mL/h)"
    } else if (inst == '30') {
        obj.instantDischarge = data.instant_discharge + "(10mL/h)"
    } else if (inst == '31') {
        obj.instantDischarge = data.instant_discharge + "(100mL/h)"
    } else if (inst == '32') {
        obj.instantDischarge = data.instant_discharge + "(L/h)"
    } else if (inst == '33') {
        obj.instantDischarge = data.instant_discharge + "(10L/h)"
    } else if (inst == '34') {
        obj.instantDischarge = data.instant_discharge + "(100L/h)"
    } else if (inst == '35') {
        obj.instantDischarge = data.instant_discharge + "(m/h)"
    } else {
        obj.instantDischarge = data.instant_discharge
    }
    //  累计流量
    let disc
    if (obj._data.discharge_unit) {
        disc = obj._data.discharge_unit.toString(16)
    } else {
        disc = 'hh'
    }

    if (disc == '26') {
        obj.discharge = data.discharge + "(mL)";
    } else if (disc == '27') {
        obj.discharge = data.discharge + "(10mL)";
    } else if (disc == '28') {
        obj.discharge = data.discharge + "(100mL)";
    } else if (disc == '29') {
        obj.discharge = data.discharge + "(L)";
    } else if (disc == '2a') {
        obj.discharge = data.discharge + "(10L)";
    } else if (disc == '2b') {
        obj.discharge = data.discharge + "(100L)";
    } else if (disc == '2c') {
        obj.discharge = data.discharge + "(m³)";
    } else {
        obj.discharge = data.discharge
    }

    //    obj.coolingCapacity = data.cooling_capacity + "(kwh)";   //  累计冷量
    //    obj.heatingCapacity = data.heating_capacity + "(kwh)";   //  累计热量

    //    obj.power = data.power + "(kwh)";              //  功率
    //    obj.instantDischarge = data.instant_discharge + "(m²/h)"; //  瞬时流量
    //    obj.discharge = data.discharge + "(m²/h)";                 //  累计流量

    obj.inTemperature = data.in_temperature + "(℃)";       //  供水温度
    obj.cycleTemperature = data.cycle_temperature + "(℃)"; //  回水温度
    obj.uptime = data.uptime + "(H)";                       //  运行时间
    obj.time = data.time;                           //  当前时间
    obj.date = data.date;                           //  当前日期
    obj._status = data.status;                        // 状态

    return obj;
}

// 故障状态 faultType: FENGGUI_FAULT / WENKONGQI_FAULT
function fenggui_faultStatus(obj, faultType) {
    let arr = [];
    for (const key in obj) {
        let msg = faultType[key];
        if (obj[key] === 1 && msg) {
            arr.push(msg);
        }
    }
    return arr;
}

// 状态 :status, 0, 1 
function fmtStr_0_1(status, str1, str2) {
    if (status === undefined) return ""
    if (status === 0) {
        return str1 || ''
    }
    if (status === 1) {
        return str2 || ''
    }
}


export default function fmtDeviceData(data) {
    let meterInfo = {
        WKQ: [],    //  存储温控器列表
        FG: [],     //  风柜列表
        RLB: [],    //  热量表列表
    };
    data.map(v => {
        let obj = {}
        obj.deviceSerial = v['device-serial'];
        obj.deviceModel = v['device-model'];

        let { name, type } = deviceType(v['device-model'])
        obj.deviceType = name;
        obj.type = type;

        obj.status = v.status;
        obj.householdname = v.householdname;
        obj.housename = v.housename;
        obj.terminalid = v.terminalid;

        let info    //  格式话表计数据
        var b = $.isEmptyObject(v.data);//判断对象是否为空

        if (type === 1) {
            if (!b) {
                info = wenkongqiInfo(v.data);
            }
            obj = Object.assign(obj, info);
            meterInfo.WKQ.push(obj)
        } else if (type === 2) {
            if (!b) {
                info = fengguiInfo(v.data);
            }
            obj = Object.assign(obj, info);
            meterInfo.FG.push(obj)
        } else if (type === 3) {
            if (!b) {
                info = reliangbiaoInfo(v.data);
            }
            obj = Object.assign(obj, info);
            meterInfo.RLB.push(obj)

        }

    })

    return meterInfo
}

